/**
 * Mirrors the backend WebSocket predicate for the chat surface. Default-
 * ignorable Unicode code points are not an instruction and must not create an
 * empty-looking bubble or turn an attachment-only send into text (#1559).
 */
const NON_MEANINGFUL_CHAT_CONTENT = /[\s\p{Default_Ignorable_Code_Point}]/gu;

export function hasMeaningfulChatContent(content: string): boolean {
  return content.replace(NON_MEANINGFUL_CHAT_CONTENT, '').length > 0;
}
